import { render } from "./SectionTravelSchedule.vue?vue&type=template&id=32d710c2&scoped=true"
import script from "./SectionTravelSchedule.vue?vue&type=script&lang=js"
export * from "./SectionTravelSchedule.vue?vue&type=script&lang=js"

import "./SectionTravelSchedule.vue?vue&type=style&index=0&id=32d710c2&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d710c2"]])

export default __exports__